var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 129,
    viewBox: "0 0 141 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.135%",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "75.004%",
    x2: "17.921%",
    y1: "89.911%",
    y2: "43.816%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.514%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M23.393 74L1 48.37 68 0l67 48.37L112.249 74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#106494",
    d: "M23.393 74L1 48.37 68 0l67 48.37L112.249 74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M0 51h131v57H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M.5 51h131v57H.5z",
    transform: "translate(-.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M135 129H1V48l67 40.59L135 48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3AD29F",
    d: "M118 20.882L103.731 10 65.934 59.026 44.94 43.016 34 57.207l28.125 21.417L69.337 84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1.026 29.738L.5 30l.06-.11-.046.015.065-.048L7.662 17l3.621 3.149 3.106 2.933-.892.444L14.5 25.33z",
    transform: "translate(-.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M10.132 21L13 23.624 0 30l6.918-8.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.132 21L13 23.624 0 30l6.918-8.748z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M7.698 18L1 30l10-9.141zM14 25.765L1 30l10.867-8zM122.864 6.988L120 11.733 141 15l-13.526-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M122.864 6.988L120 11.733 141 15l-13.526-9z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M126.423 1L141 15l-18-8.49zM121 14.654L141 15l-18.671-6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmed);
export default __webpack_public_path__ + "static/media/email-confirmed.b94881e3.svg";
export { ForwardRef as ReactComponent };